export enum GlobalElementType {
  AccordionLeftAligned = 'vm_accordion_left_align',
  TextSectionLeftAlignedWhiteBg = 'vm_text_left_align_white_background',
  TextSectionLeftAligned = 'text',
  TextSectionCenterAlignedWhiteBg = 'vm_text_center_align_white_background',
  TextSectionCenterAligned = 'textCenterAligned',  
  TileCenterAlignedWhiteBg = 'vm_tile_center_align_white_background',
  TileCenterAlignedWhiteBgClick = 'vm_tile_center_align_white_background_clickable',
  TileLeftAlignedWhiteBg = 'vm_tile_left_align_white_background',
  TileLeftAlignedWhiteBgClick = 'vm_tile_left_align_white_background_clickable',
  TileRightAlignWhiteBg = 'vm_tile_right_align_white_background',
  TileRightAlignWhiteBgClick = 'vm_tile_right_align_white_background_clickable',  
  FloatingBanner =  'floating-banner',
  LinksLeftAligned = 'vm_links',
  ActionCenterAlignWhiteBg = 'vm_action_center_align_white_background',
  ArticleListing = 'articleListing',
  TileFullWidthClickable = 'vm_tile_full_width_clickable',
  FeatureArticle = 'featureArticle',
  OrderedList = 'orderedList',
  PostcodeChecker = 'Postcode Checker',
  MediaTiles = 'Media Tiles',
  ModalSection = 'vm_modalDialog',
  CountdownCenterAligned = 'vm_datepicker',
  ExploreCards = 'explore-cards',
  Upgrade360Form = 'choiceChipAsTile'
}
